var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-file-attaching"},[_c('LinceAttachFile',{attrs:{"file":_vm.file},on:{"update:file":_vm.onAttach}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }